// extracted by mini-css-extract-plugin
export default {"message":"common_message__d3GMK","message__icon":"common_message__icon__P-90v"};